import React, { ReactNode, useEffect } from "react";
import { useAuthStore } from "./authStore";

const AuthBootstrap = ({ children }: { children: ReactNode }) => {
    const isPreparingApp = useAuthStore((s) => s.isPreparingApp);

    useEffect(() => {
        useAuthStore.getState().loadResourcesAndDataAsync();
    }, []);

    if (isPreparingApp) return null;
    return <>{children}</>;
};

export default AuthBootstrap;
